// Port of api/fuel/app/classes/controller/api/monty/tags/clear.php
import DB from 'offline/db'
import {
	persist,
	sessionUserId,
	touchAttachmentCounts,
	unauthorised,
	uniqueIndex
} from './shared'

function filterField(filter) {
	if (filter === 'collection') return 'collection_id'
	if (filter === 'ratings') return 'rating_id'
	if (filter === 'plays') return 'play_id'
	return false
}

export default function(params) {
	var userId = sessionUserId(params)
	var items = uniqueIndex(params.items || [])
	var games = uniqueIndex(params.games || [])
	var field = filterField(params.filter)
	var affectedTagIds = []
	var affectedFamilyIds = []
	var tagSeen = {}
	var familySeen = {}
	var rows = []
	var i = 0

	if (!userId) {
		return unauthorised()
	}

	if (!field) {
		return persist({
			items: items,
			games: games
		})
	}

	if (games.length) {
		rows = DB.query('SELECT DISTINCT tag_id, family_id FROM tag_attach WHERE user_id = ? AND game_id IN (' + games.map(function() { return '?' }).join(', ') + ')', [
			parseInt(userId, 10) || 0
		].concat(games))

		for (i = 0; i < rows.length; i++) {
			var gameTagId = parseInt(rows[i].tag_id, 10) || 0
			var gameFamilyId = parseInt(rows[i].family_id, 10) || 0
			if (gameTagId && !tagSeen[gameTagId]) {
				tagSeen[gameTagId] = true
				affectedTagIds.push(gameTagId)
			}
			if (gameFamilyId && !familySeen[gameFamilyId]) {
				familySeen[gameFamilyId] = true
				affectedFamilyIds.push(gameFamilyId)
			}
		}

		DB.run('DELETE FROM tag_attach WHERE user_id = ? AND game_id IN (' + games.map(function() { return '?' }).join(', ') + ')', [
			parseInt(userId, 10) || 0
		].concat(games))
	}

	if (items.length) {
		rows = DB.query('SELECT DISTINCT tag_id, family_id FROM tag_attach WHERE user_id = ? AND ' + field + ' IN (' + items.map(function() { return '?' }).join(', ') + ')', [
			parseInt(userId, 10) || 0
		].concat(items))

		for (i = 0; i < rows.length; i++) {
			var itemTagId = parseInt(rows[i].tag_id, 10) || 0
			var itemFamilyId = parseInt(rows[i].family_id, 10) || 0
			if (itemTagId && !tagSeen[itemTagId]) {
				tagSeen[itemTagId] = true
				affectedTagIds.push(itemTagId)
			}
			if (itemFamilyId && !familySeen[itemFamilyId]) {
				familySeen[itemFamilyId] = true
				affectedFamilyIds.push(itemFamilyId)
			}
		}

		DB.run('DELETE FROM tag_attach WHERE user_id = ? AND ' + field + ' IN (' + items.map(function() { return '?' }).join(', ') + ')', [
			parseInt(userId, 10) || 0
		].concat(items))
	}

	touchAttachmentCounts(affectedTagIds, affectedFamilyIds)

	return persist({
		items: items,
		games: games
	})
}
